module.exports = __webpack_public_path__ + "img/phone.5b7d04cb.svg";